import React from "react";
import type { ThreadEvent } from "@/domain/threadEvent";
import { usePhotoViewer } from "@/components/photos/PhotoViewerProvider";

export function LetterMessage({ event }: { event: ThreadEvent }) {
  const photoViewer = usePhotoViewer();

  return (
    <div className="pm-letter-message flex w-full flex-col gap-2">
      {event.text ? <div className="pm-letter-text whitespace-pre-wrap">{event.text}</div> : null}
      {event.photos.length ? (
        <div className="pm-letter-photos grid grid-cols-3 gap-2">
          {event.photos.map((p, idx) => (
            <button
              key={`${p.url}:${idx}`}
              type="button"
              className="pm-letter-photo-button aspect-square w-full overflow-hidden rounded-md"
              onClick={() => photoViewer.open(event.photos, idx)}
              aria-label={`View photo ${idx + 1}`}
            >
              <img
                src={p.url}
                alt={p.filename || "Photo"}
                className="pm-letter-photo h-full w-full object-cover [image-orientation:from-image]"
                loading="lazy"
                decoding="async"
              />
            </button>
          ))}
        </div>
      ) : null}
    </div>
  );
}
